/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.AuditChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const LearningPathAuditEntryTypename = 'com.hubspot.learning.center.playlists.core.playlist.audit.LearningPathAuditEntry';
export const LearningPathFilterAuditEntryTypename = 'com.hubspot.learning.center.playlists.core.playlist.audit.LearningPathFilterAuditEntry';
export const PlaylistAuditEntryTypename = 'com.hubspot.learning.center.playlists.core.playlist.audit.PlaylistAuditEntry';
export const PlaylistItemAuditEntryTypename = 'com.hubspot.learning.center.playlists.core.playlist.audit.PlaylistItemAuditEntry';
export const getRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.AuditChirpService',
  rpcName: 'get',
  auth: 'app',
  fingerprint: 'gt8qR_jzEq_t-pLEuXN7VpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};